module.exports = __webpack_public_path__ + "static/media/Stoebern02.1345d476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stoebern02.jpg
// module id = 353
// module chunks = 0